import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';

export default styled(({className, ...props}) => <span className={className}><Skeleton {...props} /></span>)``;
